import { useUserMeControllerUserMeQuery } from '@shared/services/apiService/apiService';
import { useAppDispatch } from '@shared/store';
import { actions } from '@shared/store/ducks';
import { useEffect } from 'react';
import { AnimatedOutlet } from '@shared/components/AnimatedOutlet';
import { InitialPageLoader } from '@shared/components/InitialPageLoader';
import { useAuthenticatedUserCompanySync } from '@shared/hooks/useAuthenticatedUserCompanySync';

export const UserLoader: React.FC = () => {
  const dispatch = useAppDispatch();
  const { data: userData, isLoading: isUserLoading, error } = useUserMeControllerUserMeQuery();
  const { isCompanyLoading } = useAuthenticatedUserCompanySync(userData?.companyId);

  useEffect(() => {
    if (userData) {
      dispatch(actions.auth.setAuthenticatedUser(userData));
    }
  }, [userData, dispatch]);

  if (isUserLoading || isCompanyLoading) return <InitialPageLoader />;
  if (error) return <div>Error during loading user data.</div>;

  return <AnimatedOutlet />;
};
